import { Box, Stack, Typography, IconButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import DeleteIcon from '@mui/icons-material/Delete';

type WallItemProps = {
  index: number;
  onAddPhoto: (files: File[]) => void;
  onRemove?: () => void;
};

export const WallItem = ({ onRemove, index, onAddPhoto }: WallItemProps) => {
  const { control, setValue } = useFormContext();

  const handlePickPhotos = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    if (files.length) onAddPhoto(files);
  };

  return (
    <Box
      sx={{
        width: '100%',
        background: '#F5F9FC',
        borderRadius: 2,
        padding: 2,
        mb: 2
      }}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography fontWeight={600} fontSize={18}>
          Wall {index + 1}
        </Typography>
        <Stack flexDirection={'row'} gap={'20px'}>
          <IconButton
            component="label"
            sx={{
              background: '#1E6FD9',
              color: 'white',
              '&:hover': { background: '#1452A5' }
            }}>
            <PhotoCameraIcon />
            <input hidden type="file" accept="image/*" multiple onChange={handlePickPhotos} />
          </IconButton>
          <IconButton onClick={onRemove}>
            <DeleteIcon />
          </IconButton>
        </Stack>
      </Stack>
      {/* PHOTOS PREVIEW */}
      <Controller
        name={`locationDetail.walls.${index}.photos`}
        control={control}
        render={({ field }) => (
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {field.value?.map((photoUrl: File, i: number) => (
              <Box
                key={i}
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: 10,
                  position: 'relative'
                }}>
                <img
                  src={URL.createObjectURL(photoUrl)}
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: 10,
                    objectFit: 'cover'
                  }}
                />
                <IconButton
                  size="small"
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const updated = field.value.filter((_: any, idx: number) => idx !== i);
                    setValue(`walls.${index}.photos`, updated);
                  }}
                  sx={{
                    position: 'absolute',
                    top: -10,
                    right: -10,
                    background: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { background: 'rgba(0,0,0,0.7)' }
                  }}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Stack>
        )}
      />
    </Box>
  );
};
